import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { IContact, IContactQuery } from "../../models/Sale";
import { useUpdateContact } from "../../query/SaleQuery";
import { notify } from "../../utils/toast";

interface ModalEditContactProps {
  open: boolean;
  record: IContact | null;
  params: IContactQuery;
  onCancel: () => void;
  onSuccess: () => void;
}

const ModalEditContact = ({
  open,
  record,
  params,
  onCancel,
  onSuccess,
}: ModalEditContactProps) => {
  const [form] = Form.useForm();
  const updateContact = useUpdateContact();

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
        phone: record.phone,
        position: record.position,
      });
    }
  }, [record, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (record) {
        await updateContact.mutateAsync({
          id: record.id,
          data: values,
          query: params,
        });
        notify.success("Cập nhật liên hệ thành công");
        form.resetFields();
        onSuccess();
      }
    } catch (error) {
      notify.error("Cập nhật liên hệ thất bại");
    }
  };

  return (
    <Modal
      title="Chỉnh sửa liên hệ"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={updateContact.isPending}
      okText="Cập nhật"
      cancelText="Hủy"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Tên liên hệ"
          name="name"
          rules={[{ required: true, message: "Vui lòng nhập tên liên hệ" }]}
        >
          <Input placeholder="Nhập tên liên hệ" />
        </Form.Item>

        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>

        <Form.Item
          label="Chức vụ"
          name="position"
          rules={[{ required: true, message: "Vui lòng nhập chức vụ" }]}
        >
          <Input placeholder="Nhập chức vụ" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditContact;
